import { render, staticRenderFns } from "./CommunityGroupSessions.vue?vue&type=template&id=6473aa5c&scoped=true&"
import script from "./CommunityGroupSessions.vue?vue&type=script&lang=js&"
export * from "./CommunityGroupSessions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6473aa5c",
  null
  
)

export default component.exports